import * as React from "react";

import { Box } from "@dropbox/dig-foundations";

import type { Atoms } from "@dropbox/dig-foundations";

export interface StageProps {
  /**
   * The title of the stage.
   */
  body: React.ReactNode;

  /**
   * The actions to display at the bottom right of the stage.
   */
  primaryActions: Array<React.ReactNode>;

  /**
   * The content to display at the bottom left of the stage.
   */
  ternaryAction: React.ReactNode;

  /**
   * The height of the stage.
   */
  height?: Atoms["height"];
}

export const Stage: React.FC<StageProps> = ({
  body,
  primaryActions,
  ternaryAction,
  height,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height={height}
    >
      <Box>{body}</Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {ternaryAction}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          columnGap="Macro Small"
        >
          {primaryActions.map((action, index) => (
            <Box key={index}>{action}</Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
